import styled, { keyframes, css } from 'styled-components';

const Pulse = keyframes`
  0% {
    opacity: 0.5;
  }
  100% {
    opacity: 0.1;
    transform: scale(1.1, 1.6);
  }
`;

export const Wrapper = styled.div`
  width: 450px;
  max-width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;

  a#back-link {
    display: flex;
    align-items: center;
    padding: 4px 10px;
    background-color: gray;
    color: white;
    text-decoration: none;
    margin-top: 20px;
    font-size: 13px;
    border-radius: 2px;

    :hover {
      opacity: 0.8;
    }
    svg {
      margin-right: 7px;
    }
  }
  #play-section {
    text-align: center;
    position: relative;
    margin-top: 20px;
    display: flex;
    flex-direction: column;

    p.the-hint {
      padding: 20px 5px;
      background-color: #eee;

      svg {
        margin-right: 7px;
      }
    }
    form {
      display: flex;
      flex-direction: column;
      margin-top: 15px;

      input {
        padding: 10px 15px;
        border-radius: 3px;
        border: 1px solid #eee;
        font-size: 14px;
        outline: none;
      }
      button[type='submit'] {
        margin: 8px 0 0 0 !important;
        padding: 9px;
        font-size: 14px;
        background-color: lightseagreen;
        color: white;

        :hover {
          opacity: 0.8;
        }
      }
    }
    .the-word {
      font-size: 30px;
      margin: 0 0 10px 0;
    }
    button {
      margin: 10px 0;
      padding: 15px 75px;
      background-color: #eee;
      margin-bottom: 4px;
      cursor: pointer;
      outline: none;
      font-size: 16px;
      border-radius: 2px;
      flex: 1 auto;
      border: none;
      text-transform: capitalize;

      a {
        text-decoration: none;
        color: black;
      }
      :hover {
        background-color: #dedede;
      }
      :last-child {
        margin-left: 5px;
      }
    }
    .play-button {
      background-color: cornflowerblue;
      color: white;

      :hover {
        background-color: #76a1ef;
      }
    }
    .play-button-record {
      position: relative;
      background-color: ${(props) => (props.active ? '#fbbbb6' : 'coral')};
      margin-right: 0;

      :hover {
        background-color: #f99991;
      }
      ${(props) =>
        props.active &&
        css`
          :before {
            position: absolute;
            content: '';
            background-color: #fbbbb6;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            animation: 1s ${Pulse} linear infinite;
            z-index: -1;
          }
        `}
      svg {
        margin-right: 10px;
      }
    }
    button.options {
      :first-child {
        margin-right: 5px;
      }
    }
    .flex {
      display: flex;
      justify-content: space-between;
    }

    #hint-section {
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      img {
        width: 26px;
        margin-right: 7px;
      }
      :hover {
        opacity: 0.8;
      }
    }

    #response-overlay {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      content: '';
      top: 0;
      left: 0%;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.7);
      z-index: 1;

      svg {
        font-size: 24px;
      }
    }
  }

  @media (max-width: 500px) {
    #play-section .flex {
      flex-direction: column;

      .options {
        :first-child {
          margin-right: 0;
        }
        :last-child {
          margin-left: 0;
        }
      }
    }
  }
`;
